// extracted by mini-css-extract-plugin
export default {"item":"UiKitSelect-module_item__lqD0F"};